import * as React from 'react';
import { useSelector } from 'react-redux';

import { ReliabilityHouses } from '../../components/Reliability/ReliabilityHouses';
import { getReliableHouses } from '../../selectors/newbuilding';
import { trackGoToReliableHouseListing } from './tracking';

export function ReliabilityHousesContainer() {
  const reliableHouses = useSelector(getReliableHouses);

  if (reliableHouses.length === 0) {
    return null;
  }

  return <ReliabilityHouses houses={reliableHouses} onClick={trackGoToReliableHouseListing} />;
}
